export const setRandomUserId = () => {
  const temporaryId = Math.floor(Math.random() * 99_999_999);
  const today = new Date().getTime();
  return `${temporaryId}-${today}`;
};

export const getOfflineIdFromStorage = (): string => {
  const analyticsDataStorage = window?.localStorage?.getItem(
    '@Conexa:analytics-storage'
  );

  if (!analyticsDataStorage) {
    const offlineId = setRandomUserId();

    window?.localStorage?.setItem(
      '@Conexa:analytics-storage',
      JSON.stringify({ offlineId })
    );
    return offlineId;
  }

  const offlineId = JSON.parse(analyticsDataStorage)?.offlineId;

  return offlineId || setRandomUserId();
};
